export const WARN_SEARCH_UNDEFINED_VALUE_IN_COL = "Tried to search in null/undefined value in column: ";
export const WARN_NO_ID_ON_RECORD = "No id field found on record.";
export const WARN_CANT_SCROLL_TO_NEW_ENTRY = "Could not scroll new entry into view!";
